export const documentsKeys = {
    all: () => ['documents'],
    contextAll: () => ['contextDocuments']
};
//# sourceMappingURL=documents.keys.js.map